module.exports = __webpack_public_path__ + "static/angelica-fcd094b2dadaddb3a03f9883f84ff4dc.jpg";